import React from 'react';
import { CameraAlt, Numbers, Accessibility, Checkroom, IceSkating, LocationOn, Lightbulb, Psychology, RemoveRedEye, Cake, Fingerprint, ContentCut, Mood, Settings, KeyboardArrowDown } from '@mui/icons-material';
import './PromptAutomatorCenterPanel.css';

const promptFields = [
  { id: 'promptTemplate', label: 'Template · Prompt', icon: Settings, level: 0 },
  { id: 'photography', label: 'Photography', icon: CameraAlt, level: 1 },
  { id: 'quantity', label: 'Quantity', icon: Numbers, level: 1 },
  { id: 'pose', label: 'Pose', icon: Accessibility, level: 1 },
  { id: 'outfit', label: 'Outfit', icon: Checkroom, level: 1 },
  { id: 'shoes', label: 'Shoes', icon: IceSkating, level: 1 },
  { id: 'location', label: 'Location', icon: LocationOn, level: 1 },
  { id: 'light', label: 'Light', icon: Lightbulb, level: 1 },
  { id: 'personalityTemplate', label: 'Template · Personality', icon: Psychology, level: 1 },
  { id: 'eyes', label: 'Eyes', icon: RemoveRedEye, level: 2 },
  { id: 'age', label: 'Age', icon: Cake, level: 2 },
  { id: 'skin', label: 'Skin', icon: Fingerprint, level: 2 },
  { id: 'hairs', label: 'Hairs', icon: ContentCut, level: 2 },
  { id: 'mood', label: 'Mood', icon: Mood, level: 2 },
];

function PromptAutomatorCenterPanel({ 
  selectedTask, 
  selectedPromptType, 
  setSelectedPromptType, 
  promptValues,
  setCurrentPromptValue
}) {
  
  const handlePromptTypeSelect = (promptType) => {
    setSelectedPromptType(promptType);
    if (promptType.id !== 'promptTemplate' && promptType.id !== 'personalityTemplate') {
      setCurrentPromptValue('');
    }
  };

  const getPromptTypeCount = (fieldId) => {
    if (!promptValues[fieldId]) return 0;
    
    if (fieldId === 'promptTemplate' || fieldId === 'personalityTemplate') {
      return typeof promptValues[fieldId] === 'string' && promptValues[fieldId].length > 0 ? 1 : 0;
    } else {
      return Array.isArray(promptValues[fieldId]) ? promptValues[fieldId].length : 0;
    }
  };


  if (!selectedTask) {
    return (
      <div className="center-panel">
        <div className="center-panel__empty">Select a task first</div>
      </div>
    );
  }

  return (
    <div className="center-panel">
      {/* Hierarchy List */}
      <div className="center-panel__list">
        {promptFields.map(field => (
          <div 
            key={field.id} 
            className={`hierarchy-item ${selectedPromptType?.id === field.id ? 'hierarchy-item--active' : ''} ${field.level === 1 ? 'hierarchy-item--sub' : ''} ${field.level === 2 ? 'hierarchy-item--sub2' : ''}`}
            data-level={field.level}
            data-field-id={field.id}
            onClick={() => handlePromptTypeSelect(field)}
          >
            <div className="hierarchy-item__content">
              <div className="hierarchy-item__icon">
                {React.createElement(field.icon)}
              </div>
              <div className="hierarchy-item__label">{field.label}</div>
            </div>
            {field.id !== 'promptTemplate' && field.id !== 'personalityTemplate' && getPromptTypeCount(field.id) > 0 && (
              <div className="hierarchy-item__badge">
                {getPromptTypeCount(field.id)}
              </div>
            )}
            {(field.id === 'promptTemplate' || field.id === 'personalityTemplate') && (
              <div className="hierarchy-item__arrow">
                <KeyboardArrowDown />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default PromptAutomatorCenterPanel;